import React from 'react'

import { SidebarMenuItemRow } from './SidebarMenuItemRow'
import type { SidebarMenuCoreProps } from './types'

export const SidebarMenuItems: React.FC<SidebarMenuCoreProps> = (props) => {
  const { items } = props
  return (
    <>
      {items.map((item) => (
        <SidebarMenuItemRow key={item.text} {...props} item={item} />
      ))}
    </>
  )
}
